/* eslint-disable prettier/prettier */
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { is } from 'ramda';
import { mediaSizes } from '../../../../utils/styles';

export const Box = styled.div`
  display: block;
`;

export const Flex = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const Center = styled(Flex)`
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
export const Stack = styled(Flex)`
  flex-direction: column;
  > * + * {
    margin-top: ${props =>
      is(Number, props.spacing) ? `${props.spacing * 0.25}em` : props.spacing};
  }
`;
export const HStack = styled(Flex)`
  flex-direction: row;
  > * + * {
    margin-left: ${props =>
      is(Number, props.spacing) ? `${props.spacing * 0.25}em` : props.spacing};
  }
`;

export const Divider = styled(Box)`
  border-right: 1px solid #fff;
  margin-left: 0.25em;
  margin-right: 0.25em;
  ${mediaSizes.md(`
    margin-left: .5em;
    margin-right: .5em;
  `)};
`;
export const Heading = styled(Box)``;
export const Image = styled.img``;

export const Input = forwardRef(({ ...props }, ref) => (
  <input ref={ref} variant="flushed" color="#7b7b7b" size="lg" {...props} />
));



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/ui/index.js